

































import { Component, Vue } from "vue-property-decorator";

@Component
export default class AwaikenUnitTextComponent extends Vue {
  readonly w = 792;
  readonly h = 792 * 1.5;
}
